(() => {
  const body = document.body;
  if (!body || !body.classList.contains('template-index')) return;

  const sections = Array.from(document.querySelectorAll([
    '.section-collection-list',
    '.section-featured-collection',
    '.section-rich-text',
    '.section-scrolling-images',
    '.section-shoppable-video-reels',
    '.section-featured-product',
    '.section-testimonials'
  ].join(','))).filter((section) => !section.hidden);

  if (!sections.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // The mobile collection rail is horizontally scrollable. Some browsers can
  // treat even a stationary tap on an image as the beginning of a drag and
  // cancel the anchor's click. Preserve swiping, but explicitly navigate when
  // the pointer is released without meaningful movement.
  document.querySelectorAll('.section-collection-list .collection-card__image > a.collection-card__link').forEach((link) => {
    let pointerStart = null;

    link.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) return;
      pointerStart = { x: event.clientX, y: event.clientY };
    }, { passive: true });

    link.addEventListener('pointercancel', () => {
      pointerStart = null;
    }, { passive: true });

    link.addEventListener('pointerup', (event) => {
      if (!pointerStart || event.button !== 0) return;

      const distance = Math.hypot(
        event.clientX - pointerStart.x,
        event.clientY - pointerStart.y
      );
      pointerStart = null;

      if (distance > 10 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      window.location.assign(link.href);
    });
  });

  sections.forEach((section, index) => {
    section.classList.add('bb-home-reveal');
    section.style.setProperty('--bb-reveal-delay', `${(index % 2) * 55}ms`);
  });

  if (reduceMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('is-visible'));
    return;
  }

  document.documentElement.classList.add('bb-home-motion');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -10% 0px'
  });

  sections.forEach((section) => observer.observe(section));
})();
